import React, { useEffect, useState } from 'react'
import t from 'helpers/I18n'

// import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from '../../base-components/step-footer-action';
import SelectMultipleInput from '../../base-components/base-input-select-multiple';
import getStep from '../../../helpers/getStep';

const JoinReason = ({ _step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const data = getDataFromContext(step_ID)
    const name = step_ID

    const options= [
        { value: 1, label: t("financial_infos.financial_info_purpose_of_pro_account.operations")},
        { value: 2, label: t("financial_infos.financial_info_purpose_of_pro_account.saving") },
        { value: 3, label: t("financial_infos.financial_info_purpose_of_pro_account.investment") },
        { value: 4, label: t("financial_infos.financial_info_purpose_of_pro_account.private_wealth") },
        { value: 5, label: t("financial_infos.financial_info_purpose_of_pro_account.heritage") },
        // { value: 6, label: t("financial_infos.financial_info_purpose_of_pro_account.loan") },
        // { value: 7, label: t("financial_infos.financial_info_purpose_of_pro_account.for_salary") },
        // { value: 8, label: t("financial_infos.financial_info_purpose_of_pro_account.internal_operation") },
        { value: 6, label: t("financial_infos.financial_info_purpose_of_pro_account.other") },
    ]

    const [defaultSelected, setDefaultSelected] = useState(data && data[name])
    const [inputData, setInputData] = useState({[name]:defaultSelected })
    const [isLoading, setIsLoading] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const [optionList, setOptionList] = useState([...options])
    const [nextTick, setNextTick] = useState(false)

    const getInputValue = (name, value, uVal) => {
        console.log('getinputvalue = ', value, uVal)

        let _value = value
            // checkOption(_value)
        
        let validCheck =  _value
        setIsValid(validCheck.length > 0 && validCheck !== "")

        setInputData({
            [name]: _value
        })
       
    }
    
    const handleOtherSource = () => {
        _step_service({ step_ID, setIsLoading, next_step: "join-reason-other"})
    }

     const action = () => {
           setDataToContext(step_ID, step_URL, step_ID, inputData[name]) 
        //  if (inputData[name].includes('6')) { handleOtherSource() } else {setNextTick(true) }
         setNextTick(true) 
    }

    useEffect(() => {
    }, [inputData])

    useEffect(() => {
    }, [defaultSelected])

    useEffect(() => {
        if (nextTick) {
         if (inputData[name].includes('6')) { _step_service({ step_ID, setIsLoading, next_step: "join-reason-other"}) } else {_step_service({ step_ID, setIsLoading, next_step: "/id-card" }) }
        } 
    }, [nextTick])

    useEffect(() => {
       getStep(['join_reason']).then(res => {
           setDefaultSelected(res[name] !== "NULL" ? res[name] : "")
                       console.log("resee => ", res)

            setIsValid(res !== "" && res.join_reason !== "NULL")
            setInputData({[name]:res[name]})
            setDataToContext(step_ID, step_URL, step_ID, res[name]) 
       })
        
                    if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "2",
stepName: "financial info:purpose of pro account",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }
    }, [])

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{t("financial_infos.financial_info_purpose_of_pro_account.title")}</h3>
                    <p>{t("financial_infos.financial_info_purpose_of_pro_account.text")}</p>
                </BaseParagraph>

                <SelectMultipleInput type={"multiple-select"} name={"join_reason"}
                    options={optionList}
                    getInputValue={getInputValue}
                    value={inputData[step_ID]}
                    defaultSelect={defaultSelected ? defaultSelected : ""}

                />

                <StepFooterAction caption={t('general.continue')}  action={action} disabled={!isValid} />
            </StepsLoader>
        </>
    )
}

JoinReason.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}

export default JoinReason